<template>
    <div>
<!--        <vue-html2pdf-->
<!--            :show-layout="false"-->
<!--            :float-layout="true"-->
<!--            :enable-download="true"-->
<!--            :preview-modal="false"-->
<!--            filename="รายงานภาพรวมเงินเดือน"-->
<!--            :paginate-elements-by-height="1400"-->
<!--            :pdf-quality="1"-->
<!--            :manual-pagination="false"-->
<!--            pdf-format="a4"-->
<!--            pdf-orientation="landscape"-->
<!--            pdf-content-width="1320px"-->

<!--            @progress="onProgress($event)"-->
<!--            ref="html2Pdf"-->
<!--        >-->
<!--            <section slot="pdf-content">-->
<!--                &lt;!&ndash; PDF Content Here &ndash;&gt;-->
<!--                <content-to-print :data="data"-->
<!--                                  :date="search.date"-->
<!--                                  :employee="search.employee"-->
<!--                                  :department="search.department"-->
<!--                                  :type="search.type"/>-->
<!--            </section>-->
<!--        </vue-html2pdf>-->
        <br>
        <br>
        <date-picker v-model="search.date"
                     range
                     class="w-100"
                     placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                     :format="changeFormat"
                     :lang="lang" confirm>
        </date-picker>
        <multiselect
            v-model="search.type"
            :options="optionType"
            multiple
            style="height: 100%"
            :closeOnSelect="false"
            placeholder="ประเภท"
            :show-labels="false">
        </multiselect>
        <multiselect
            v-model="search.employee"
            :options="optionEmployee"
            label="name"
            multiple
            style="height: 100%"
            :closeOnSelect="false"
            placeholder="ค้นหาพนักงาน"
            :show-labels="false"
            :customLabel="employeeLabel"
            track-by="id">
        </multiselect>
        <multiselect
            v-model="search.department"
            :options="optionDepartment"
            placeholder="ค้นหาแผนก"
            multiple
            style="height: 100%"
            :closeOnSelect="false"
            :show-labels="false"
            label="department_name"
            track-by="id">
        </multiselect>

        <button class="btn btn-success my-2 my-sm-0"
                @click="startGenerate"
                type="button">
            <icon name="search"></icon>
            PDF
        </button>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg"></loading>
        </b-modal>
    </div>
</template>

<script>
// import VueHtml2pdf from 'vue-html2pdf'
import Loading from "@/components/Utility/Loading";
import ContentToPrint from "@/components/ContentToPrint";
import moment from "moment";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'

export default {
    components: {
        ContentToPrint,
        Loading,
        // VueHtml2pdf,
        Multiselect,
        DatePicker
    },
    data () {
        return {
            msg : '',
            status_loading : '',
            data : [],
            search :{
                date : [],
                employee : [],
                department : [],
                type : [],
            },
            optionDepartment : [],
            optionEmployee : [],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/'+year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            optionType :[
                'เงินประกันสังคม',
                'ร้านค้า',
                'ค่าเช่าห้อง',
                'หักขาดงาน',
                'หักค่าเงินเบิกล่วงหน้า',
                'ค่าธรรมเนียม Bank',
                'ค่าโฟมเสียหาย',
                'หักค่าบัตรพนักงาน',
                'ค่าประกันความเสียหาย',
                'หักภาษีเงินได้บุคคลธรรมดา',
                'หักค่าประกันห้อง',
                'หักค่าบริการ',
                'ค่าโทรศัพท์',
                'ค่าขนส่ง',
                'ค่าแก๊สรถยนต์คืน',
                'รายจ่ายอื่นๆ',
            ]
        }
    },
    created() {
        this.getData();
        this.getEmployeeAll();
        this.getDepartmentAll();
    },
    methods: {
        employeeLabel(option){
            return `${option.employee_no} - ${option.name}`
        },
        getData(){
            this.$store.dispatch('Payment/getDataSumary').then(res=>{
                this.data = res.data
            })
        },
        startGenerate(){
            this.showLoading();
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.generateReport();
        },
        generateReport () {
            // this.$refs.html2Pdf.generatePdf()
        },
        onProgress(e){
            this.showLoading();
            if (e == 100){
                this.hideLoading();
            }else{
                this.showLoading();
            }
        },
        showLoading(){
            this.$refs.loading.show();
        },
        hideLoading(){
            this.$refs.loading.hide();
        },
        getEmployeeAll(){
            this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                this.optionEmployee = res;
            })
        },
        getDepartmentAll(){
            this.$store.dispatch("Department/getAllDepartment").then(res=>{
                this.optionDepartment = res;
            })
        },
    },
}
</script>

<style scoped>

</style>
